export default {
  "title": "Politique de confidentialité de DeMaxtore.com",
  "subtitle": "La présente politique de confidentialité explique comment Demakstore Gıda İhracat San. ve Tic. Ltd. Şti., exploitant la marque DeMaxtore, collecte et traite les données personnelles et professionnelles.",
  "lastUpdated": "Dernière mise à jour : 26 mai 2026",
  "back": "← Retour à l'accueil",
  "sections": [
    {
      "title": "1. À propos de DeMaxtore",
      "blocks": [
        {
          "type": "p",
          "text": "DeMaxtore est la marque et la plate-forme numérique exploitées par Demakstore Gıda İhracat San. ve Tic. Ltd. Şti."
        },
        {
          "type": "p",
          "text": "DeMaxtore est une plateforme B2B qui aide les acheteurs internationaux à s'approvisionner auprès de fabricants turcs vérifiés, à comparer les offres de fret, à gérer les processus d'inspection et à suivre les expéditions du ramassage en usine à la livraison en entrepôt."
        },
        {
          "type": "p",
          "text": "Quelques-uns de nos services :"
        },
        {
          "type": "ul",
          "items": [
            "Répertoire des fournisseurs et services de liste des fabricants",
            "Outils de demande des acheteurs et de communication avec les fournisseurs",
            "Processus d'approvisionnement et d'appel d'offres CommodityBid",
            "Services de comparaison de fret FreightIQ",
            "Coordination de l'inspection",
            "Suivi des expéditions ",
            "Gestion des processus d'importation et services de soutien connexes"
          ]
        }
      ]
    },
    {
      "title": "DONNÉES PERSONNELLES QUE NOUS RÉCOLTONS RÉCOLTÉES",
      "blocks": [
        {
          "type": "p",
          "text": "Nous pouvons collecter des données personnelles directement auprès des utilisateurs, des entreprises, des fournisseurs, des acheteurs, des prestataires logistiques ou d'autres partenaires commerciaux lorsqu'ils utilisent notre site Web ou nos services."
        },
        {
          "type": "p",
          "text": "Les données personnelles que nous recueillons comprennent :"
        },
        {
          "type": "ul",
          "items": [
            "Nom complet",
            "Désignation de l'entreprise",
            "Intitulé du poste ou service",
            "Adresse e-mail professionnelle",
            "Numéro de téléphone",
            "Pays et ville",
            "Site web de l'entreprise",
            "Demandes de sourcing de produits",
            "Informations sur le fournisseur ou le fabricant",
            "Informations relatives au fret, à l'expédition et à la livraison",
            "Détails de la demande d'inspection",
            "Messages, demandes de renseignements, formulaires et dossiers de communication",
            "Informations de connexion au compte, le cas échéant",
            "Adresse IP, type de navigateur, informations sur l'appareil et données d'utilisation du site Web"
          ]
        },
        {
          "type": "p",
          "text": "Nous traitons généralement des informations dans un contexte B2B et ne collectons pas intentionnellement de données personnelles sensibles, sauf si elles sont fournies volontairement par l'utilisateur et nécessaires à un service spécifique."
        }
      ]
    },
    {
      "title": "Comment nous collectons vos données personnelles. ",
      "blocks": [
        {
          "type": "p",
          "text": "Nous pouvons recueillir vos données personnelles lors :"
        },
        {
          "type": "ul",
          "items": [
            "Visitez www.demaxtore.com",
            "Remplissez un formulaire de contact",
            "Soumettre une demande de sourcing",
            "Créer ou utiliser un compte acheteur ou fournisseur",
            "Utiliser CommodityBid",
            "Utiliser FreightIQ",
            "Demander une comparaison de fret",
            "Demander des services d'inspection",
            "Demander une assistance pour le suivi des expé",
            "Contactez-nous par e-mail, téléphone, WhatsApp ou d'autres canaux de communication",
            "Abonnez-vous aux mises à jour, aux newsletters ou aux communications commerciales",
            "Communiquer avec les représentants DeMaxtore"
          ]
        },
        {
          "type": "p",
          "text": "Nous pouvons également recevoir des informations commerciales de fournisseurs, de fabricants, de partenaires logistiques, de partenaires d'inspection ou de sources commerciales accessibles au public lorsque la loi le permet."
        }
      ]
    },
    {
      "title": "FINALITÉS DU TRAITEMENT DES DONNÉES À CARACTÈRE PERSONNEL",
      "blocks": [
        {
          "type": "p",
          "text": "Nous traitons ces données personnelles aux fins suivantes :"
        },
        {
          "type": "ul",
          "items": [
            "Fournir un accès au site Web et aux services de Demaxtore",
            "Gérer les demandes des acheteurs et des fournisseurs",
            "Pour mettre en relation les acheteurs avec les fournisseurs ou fabricants concernés",
            "Pour traiter les demandes d'approvisionnement via CommodityBid",
            "Pour comparer les offres de fret via FreightIQ",
            "Coordonner les services d'inspection et de suivi des expéditions",
            "Pour communiquer avec les utilisateurs, les acheteurs, les fournisseurs et les partenaires logistiques",
            "Pour fournir une assistance aux clients",
            "Pour vérifier les informations de l'entreprise ou du fournisseur",
            "Pour améliorer notre site Web, nos services et l'expérience utilisateur",
            "Pour envoyer des communications commerciales, de service ou de marketing",
            "Pour prévenir la fraude, l'utilisation abusive, le spam ou les activités non autorisées",
            "Pour se conformer aux obligations légales, contractuelles, réglementaires ou fiscales",
            "Protéger les droits, la sécurité, la réputation et les intérêts légitimes de DeMaxtore"
          ]
        }
      ]
    },
    {
      "title": "La Base Juridique pour le Traitement",
      "blocks": [
        {
          "type": "p",
          "text": "Le cas échéant, en vertu du RGPD ou de lois similaires sur la protection des données, nous traitons les données personnelles sur la base d'un ou de plusieurs des motifs juridiques suivants :"
        },
        {
          "type": "ul",
          "items": [
            "Exécution d'un contrat : lorsque le traitement est nécessaire pour fournir nos services",
            "Intérêt légitime : pour la communication B2B, l'amélioration des services, la prévention de la fraude, la coordination de l'approvisionnement, la coordination logistique et le développement commercial",
            "Consentement : lorsque les utilisateurs donnent leur consentement pour des communications marketing, des cookies ou des communications facultatives",
            "Obligation légale : lorsque le traitement est requis par la loi, la réglementation, l'ordonnance du tribunal ou la demande de l'autorité publique applicable"
          ]
        },
        {
          "type": "p",
          "text": "Les utilisateurs peuvent retirer leur consentement à tout moment lorsque le traitement est basé sur le consentement."
        }
      ]
    },
    {
      "title": "Partage des données personnelles",
      "blocks": [
        {
          "type": "p",
          "text": "Afin de fournir nos services, nous pouvons partager des données personnelles ou commerciales pertinentes avec :"
        },
        {
          "type": "ul",
          "items": [
            "Fournisseurs et fabricants vérifiés",
            "Acheteurs qui soumettent des demandes d'approvisionnement",
            "Transitaires et partenaires logistiques",
            "Prestataires de services d'inspection",
            "Prestataires de services de paiement, comptables, juridiques ou de conformité",
            "Fournisseurs de services d'infrastructure informatique, d'hébergement, de CRM, de messagerie, d'analyse et de cloud",
            "Consultants commerciaux ou représentants autorisés de DeMaxtore",
            "Autorités publiques, tribunaux ou régulateurs lorsque la loi l'exige"
          ]
        },
        {
          "type": "p",
          "text": "Par exemple, lorsqu'un acheteur soumet une demande d'approvisionnement, certaines coordonnées professionnelles et certains détails de la demande peuvent être partagés avec les fournisseurs ou les partenaires de service concernés pour faciliter le processus d'approvisionnement."
        },
        {
          "type": "p",
          "text": "Nous ne vendons ni ne louons vos données personnelles à des tiers. "
        }
      ]
    },
    {
      "title": "7. Répertoire des fournisseurs et profils d'entreprise",
      "blocks": [
        {
          "type": "p",
          "text": "Demaxtore peut afficher des informations relatives à l'entreprise dans son répertoire des fournisseurs ou son interface de plateforme. Cela peut inclure :"
        },
        {
          "type": "ul",
          "items": [
            "Désignation de l'entreprise",
            "Matières des niveaux scolaires",
            "On recourt souvent à la «pyramide des âges» pour illustrer la répartition des classes d’âge dans un pays ou une ville.",
            "Description de l'entreprise",
            "Site web de l'entreprise",
            "Options de contact ou de demande",
            "Statut de la vérification",
            "Détails commerciaux pertinents fournis par l'entreprise"
          ]
        },
        {
          "type": "p",
          "text": "Les entreprises sont responsables de s'assurer que les informations qu'elles fournissent sont exactes, légales, à jour et ne portent pas atteinte aux droits d'un tiers."
        }
      ]
    },
    {
      "title": "8. Messagerie, formulaires de contact et demandes de renseignements",
      "blocks": [
        {
          "type": "p",
          "text": "Lorsque les utilisateurs envoient des demandes de renseignements, des messages ou des demandes de sourcing via DeMaxtore, le contenu de ces communications peut être examiné par l'équipe de DeMaxtore à des fins opérationnelles, de support, de qualité, de conformité et de gestion des services."
        },
        {
          "type": "p",
          "text": "Les messages peuvent également être partagés avec les fournisseurs, les acheteurs, les prestataires logistiques, les partenaires d'inspection ou d'autres parties impliquées dans le service demandé."
        },
        {
          "type": "p",
          "text": "Les utilisateurs ne doivent pas soumettre de contenu illégal, trompeur, offensant, frauduleux, lié au spam ou enfreignant des tiers via notre site Web ou nos services."
        }
      ]
    },
    {
      "title": "9. Données CommodityBid",
      "blocks": [
        {
          "type": "p",
          "text": "Lorsque vous utilisez CommodityBid, nous pouvons traiter des informations telles que :"
        },
        {
          "type": "ul",
          "items": [
            "Demandes d'approvisionnement des acheteurs",
            "Les spécifications du produit",
            "Quantité, emballage et attentes de livraison",
            "Prix cible ou détails de l'enchère",
            "Offres fournisseurs",
            "le nom de l'entreprise et les coordonnées;",
            "Dossiers de communication liés au processus d'appel d'offres"
          ]
        },
        {
          "type": "p",
          "text": "Ces données sont utilisées pour gérer les processus d'appel d'offres B2B structurés entre les acheteurs et les fournisseurs ou fabricants vérifiés."
        }
      ]
    },
    {
      "title": "10. FreightIQ et données d'expédition",
      "blocks": [
        {
          "type": "p",
          "text": "Lorsque nous utilisons les services FreightIQ, de comparaison de fret ou de suivi des expéditions, nous pouvons traiter des données telles que :"
        },
        {
          "type": "ul",
          "items": [
            "Détails de la prise en charge et de la livraison",
            "Type d'expédition",
            "Informations sur le produit ou la cargaison",
            "Exigences en matière de fret",
            "Offres du transitaire",
            "Recette et suivi des mises à jour.",
            "Informations commerciales liées aux douanes ou à la documentation",
            "Coordonnées des acheteurs, fournisseurs et partenaires logistiques"
          ]
        },
        {
          "type": "p",
          "text": "Ces données sont utilisées pour comparer les options de fret, coordonner la logistique et prendre en charge la visibilité des expéditions de porte à porte."
        }
      ]
    },
    {
      "title": "11. Données des services d'inspection",
      "blocks": [
        {
          "type": "p",
          "text": "Lorsque des services d'inspection sont demandés, nous pouvons traiter :"
        },
        {
          "type": "ul",
          "items": [
            "Détails du produit",
            "Informations sur l'usine ou le fournisseur",
            "Lieu de contrôle",
            "Exigences en matière d’inspection",
            "Photos, rapports ou documents de contrôle qualité",
            "Coordonnées des parties concernées"
          ]
        },
        {
          "type": "p",
          "text": "Ces informations sont utilisées pour coordonner les services d'inspection et communiquer les résultats de l'inspection aux parties commerciales concernées."
        }
      ]
    },
    {
      "title": "12. WhatsApp Business et autres canaux de communication",
      "blocks": [
        {
          "type": "p",
          "text": "DeMaxtore peut utiliser WhatsApp Business, e-mail, téléphone, SMS ou d'autres canaux de communication pour communiquer avec les utilisateurs, les acheteurs, les fournisseurs et les partenaires commerciaux."
        },
        {
          "type": "p",
          "text": "Si vous nous contactez via WhatsApp ou un autre outil de communication tiers, votre communication peut également être soumise à la politique de confidentialité de ce fournisseur tiers."
        },
        {
          "type": "p",
          "text": "Nous pouvons stocker des enregistrements de communication à des fins commerciales, d'assistance, juridiques ou de qualité de service, à moins que la suppression ne soit demandée et qu'aucune obligation légale de conservation ne s'applique."
        }
      ]
    },
    {
      "title": "Cookies et technologies similaires",
      "blocks": [
        {
          "type": "p",
          "text": "DeMaxtore peut utiliser des cookies et des technologies similaires pour :"
        },
        {
          "type": "ul",
          "items": [
            "Assurer la fonctionnalité du site Web",
            "Améliore l'expérience de l'utilisateur",
            "Analyser le trafic du site Web",
            "Mémoriser les préférences de l'",
            "Renforcer la sécurité et la prévention des fraudes.",
            "Mesurer la performance marketing"
          ]
        },
        {
          "type": "p",
          "text": "Les utilisateurs peuvent gérer ou désactiver les cookies via les paramètres de leur navigateur. Certaines fonctionnalités du site Web peuvent ne pas fonctionner correctement si les cookies sont désactivés."
        }
      ]
    },
    {
      "title": "Communications marketing ",
      "blocks": [
        {
          "type": "p",
          "text": "Nous pouvons contacter les utilisateurs et les représentants commerciaux par e-mail, téléphone, WhatsApp ou d'autres canaux de communication à des fins commerciales ou liées au service, lorsque la loi le permet."
        },
        {
          "type": "p",
          "text": "Les utilisateurs peuvent se désabonner des communications marketing à tout moment en nous contactant ou en utilisant l'option de désabonnement, le cas échéant."
        },
        {
          "type": "p",
          "text": "Même après avoir choisi de ne pas participer, nous pouvons toujours envoyer des communications liées au service, transactionnelles, juridiques ou de sécurité si nécessaire."
        }
      ]
    },
    {
      "title": "Transferts internationaux de données",
      "blocks": [
        {
          "type": "p",
          "text": "Étant donné que DeMaxtore opère dans un environnement commercial B2B international, les données personnelles peuvent être transférées ou consultées à partir de pays situés en dehors du pays de résidence de l'utilisateur."
        },
        {
          "type": "p",
          "text": "Lorsque la loi applicable l'exige, nous prenons des mesures de protection appropriées pour protéger les données personnelles lors des transferts internationaux, y compris des mesures contractuelles, techniques et organisationnelles."
        }
      ]
    },
    {
      "title": "Conservation des données",
      "blocks": [
        {
          "type": "p",
          "text": "Nous conservons les données personnelles uniquement aussi longtemps que nécessaire aux fins décrites dans la présente Politique de confidentialité, notamment :"
        },
        {
          "type": "ul",
          "items": [
            "services dans un",
            "Gestion des relations d'affaires",
            "Gestion des processus d'approvisionnement, de logistique, d'appel d'offres et d'inspection",
            "respect des obligations légales.",
            "Le règlement des différends",
            "Prévention de la fraude ou de l'utilisation abusive",
            "la tenue de nos registres commerciaux&#160;;"
          ]
        },
        {
          "type": "p",
          "text": "Lorsque les données personnelles ne sont plus nécessaires, nous les supprimons, les anonymisons ou les archivons en toute sécurité conformément aux lois applicables et aux pratiques de conservation interne."
        }
      ]
    },
    {
      "title": "Sécurité des données.",
      "blocks": [
        {
          "type": "p",
          "text": "Nous prenons des mesures techniques et organisationnelles raisonnables pour protéger les données personnelles contre :"
        },
        {
          "type": "ul",
          "items": [
            "﻿Accès non autorisé",
            "Perte accidentelle",
            "Mauvaise utilisation",
            "Modification",
            "Divulgation",
            "Destruction",
            "Incidents sur le plan de la sécurité"
          ]
        },
        {
          "type": "p",
          "text": "Cependant, aucun système basé sur Internet ne peut être garanti d'être complètement sécurisé. Les utilisateurs sont responsables de la confidentialité des informations de connexion à leur compte et de nous informer immédiatement en cas d'accès non autorisé ou de problèmes de sécurité présumés."
        }
      ]
    },
    {
      "title": "18. Droits de l'utilisateur",
      "blocks": [
        {
          "type": "p",
          "text": "Selon les lois applicables en matière de protection des données, les utilisateurs peuvent avoir le droit de :"
        },
        {
          "type": "ul",
          "items": [
            "Accéder à leurs données personnelles.",
            "Demander la correction de données inexactes",
            "Demande d’effacement des données personnelles",
            "S'opposer à certaines activités de traitement",
            "Limiter le traitement",
            "Retirer le consentement. ",
            "Demander la portabilité des données",
            "Déposer une plainte auprès d'une autorité compétente en matière de protection des données."
          ]
        },
        {
          "type": "p",
          "text": "Pour exercer ces droits, les utilisateurs peuvent contacter DeMaxtore en utilisant les coordonnées fournies ci-dessous."
        }
      ]
    },
    {
      "title": "14. Sites Web et Services de tiers",
      "blocks": [
        {
          "type": "p",
          "text": "Notre site Web peut contenir des liens vers des sites Web, des plateformes, des fournisseurs de logistique, des fournisseurs, des fabricants ou des fournisseurs de services tiers."
        },
        {
          "type": "p",
          "text": "DeMaxtore n'est pas responsable des pratiques, du contenu, de la sécurité ou des politiques de confidentialité des sites Web ou des services tiers. Les utilisateurs doivent consulter les politiques de confidentialité de ces tiers avant de partager des données personnelles avec eux."
        }
      ]
    },
    {
      "title": "La confidentialité des enfants",
      "blocks": [
        {
          "type": "p",
          "text": "Les services de DeMaxtore sont destinés aux utilisateurs professionnels et ne s'adressent pas aux enfants. Nous ne collectons pas sciemment de données personnelles de personnes de moins de 18 ans."
        },
        {
          "type": "p",
          "text": "Si nous apprenons que nous avons collecté des données personnelles d'un enfant sans autorisation appropriée, nous prendrons des mesures raisonnables pour supprimer ces données."
        }
      ]
    },
    {
      "title": "Modifications apportées à cette politique de confidentialité",
      "blocks": [
        {
          "type": "p",
          "text": "DeMaxtore peut mettre à jour cette politique de confidentialité de temps à autre pour refléter les changements dans nos services, les exigences légales, les opérations commerciales ou les pratiques de traitement des données."
        },
        {
          "type": "p",
          "text": "La version mise à jour sera publiée sur www.demaxtore.com avec la date révisée de « Dernière mise à jour ». L'utilisation continue de notre site Web ou de nos services après la publication des modifications signifie que les utilisateurs reconnaissent la politique de confidentialité mise à jour."
        }
      ]
    },
    {
      "title": "22. Contact",
      "blocks": [
        {
          "type": "p",
          "text": "Pour toute question, demande ou réclamation concernant la présente Politique de confidentialité ou le traitement des données personnelles, veuillez nous contacter :"
        },
        {
          "type": "ul",
          "items": [
            "Demakstore Gıda İhracat San. ve Tic. Ltd. Şti.",
            "Marque d'exploitation : DeMaxtore",
            "Site Web : www.demaxtore.com",
            "E-mail : support@demaxtore.com",
            "E-mail alternatif : demaxtore@demaxtore.com"
          ]
        }
      ]
    }
  ]
};
